import speakingurl from 'speakingurl'
import OtherProject, { NON_POWER_PROJECT_TYPES } from './OtherProject'

class BioheatProject extends OtherProject {
  constructor (obj) {
    super(obj)

    this.name = obj.Facility
    this.owner = ''
    this.operator = ''
    this.id = speakingurl(`${this.name}-${this.owner}`)

    this.city = obj.City
    this.technology = obj.Technology

    this._type = NON_POWER_PROJECT_TYPES['Bioheat']
    this.typeShortName = this._type.shortName
    this.icon = this._type.icon
  }
}

export default BioheatProject



// WEBPACK FOOTER //
// ./src/models/BioheatProject.js